/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './productItem/productItem.component.ngfactory';
import * as i2 from '../../../../../app/components/Managment/productManagement/productItem/productItem.component';
import * as i3 from '@angular/common';
import * as i4 from 'ngx-pagination';
import * as i5 from '../pagination/managementPagination.component.ngfactory';
import * as i6 from '../../../../../app/components/Managment/pagination/managementPagination.component';
import * as i7 from '../../../../../app/components/Managment/productManagement/productManagement.component';
import * as i8 from './modal/productModal.component.ngfactory';
import * as i9 from '../../../../../app/components/Managment/productManagement/modal/productModal.component';
import * as i10 from '../../../../../app/services/productService';
import * as i11 from 'ng2-toastr/src/toast-manager';
import * as i12 from '../search/managementSearch.component.ngfactory';
import * as i13 from '../../../../../app/components/Managment/search/managementSearch.component';
import * as i14 from '@angular/router';
const styles_ProductManagementComponent:any[] = ([] as any[]);
export const RenderType_ProductManagementComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ProductManagementComponent,data:{}});
function View_ProductManagementComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'product-item',([] as any[]),(null as any),(null as any),(null as any),
          i1.View_ProductItemComponent_0,i1.RenderType_ProductItemComponent)),i0.ɵdid(49152,
          (null as any),0,i2.ProductItemComponent,([] as any[]),{product:[0,'product'],
              productModal:[1,'productModal']},(null as any)),(_l()(),i0.ɵted((null as any),
          [' ']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    const currVal_1:any = i0.ɵnov((<any>(<any>_v.parent).parent),1);
    _ck(_v,3,0,currVal_0,currVal_1);
  },(null as any));
}
function View_ProductManagementComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),5,'div',[['class',
      'row']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),2,(null as any),View_ProductManagementComponent_2)),i0.ɵdid(802816,
          (null as any),0,i3.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),i0.ɵpid(0,i4.PaginatePipe,[i4.PaginationService]),
      (_l()(),i0.ɵted((null as any),[' ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵunv(_v,3,0,i0.ɵnov(_v,4).transform(_co.products,_co.config));
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
function View_ProductManagementComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'row'],['style','text-align:center']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
      i0.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
      [' No matching results! '])),(_l()(),i0.ɵted((null as any),[' ']))],(null as any),
      (null as any));
}
function View_ProductManagementComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),5,'div',[['class',
      'row']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          2,'management-pagination',([] as any[]),(null as any),[[(null as any),'searchEventEmitter']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('searchEventEmitter' === en)) {
              const pd_0:any = ((<any>_co.search()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_ManagementPaginationComponent_0,i5.RenderType_ManagementPaginationComponent)),
      i0.ɵdid(49152,(null as any),0,i6.ManagementPaginationComponent,([] as any[]),
          {config:[0,'config']},{searchEventEmitter:'searchEventEmitter'}),(_l()(),
          i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),[' ']))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.config;
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
export function View_ProductManagementComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'product-modal',
      ([] as any[]),(null as any),[[(null as any),'productSaved']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i7.ProductManagementComponent = _v.component;
        if (('productSaved' === en)) {
          const pd_0:any = ((<any>_co.onProductSaved($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i8.View_ProductModalComponent_0,i8.RenderType_ProductModalComponent)),i0.ɵdid(49152,
      [['productModal',4]],0,i9.ProductModalComponent,[i10.ProductService,i11.ToastsManager],
      {idToBlur:[0,'idToBlur']},{productSaved:'productSaved'}),(_l()(),i0.ɵted((null as any),
      [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),17,'div',[['class','main-content']],
      [[1,'id',0]],(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
      14,'div',[['class','container-fluid']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
      i0.ɵeld(0,(null as any),(null as any),2,'management-search',([] as any[]),(null as any),
          [[(null as any),'searchEventEmitter'],[(null as any),'queryChange']],(_v,
              en,$event) => {
            var ad:boolean = true;
            var _co:i7.ProductManagementComponent = _v.component;
            if (('searchEventEmitter' === en)) {
              _co.config.currentPage = 1;
              const pd_0:any = ((<any>_co.search()) !== false);
              ad = (pd_0 && ad);
            }
            if (('queryChange' === en)) {
              const pd_1:any = ((<any>(_co.query = $event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i12.View_ManagementSearchComponent_0,i12.RenderType_ManagementSearchComponent)),
      i0.ɵdid(49152,(null as any),0,i13.ManagementSearchComponent,([] as any[]),{helpText:[0,
          'helpText'],query:[1,'query']},{searchEventEmitter:'searchEventEmitter',
          queryChange:'queryChange'}),(_l()(),i0.ɵted(0,[' '])),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_ProductManagementComponent_1)),i0.ɵdid(16384,(null as any),0,i3.NgIf,
          [i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_ProductManagementComponent_3)),i0.ɵdid(16384,(null as any),
          0,i3.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ProductManagementComponent_4)),i0.ɵdid(16384,
          (null as any),0,i3.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵted((null as any),[' ']))],(_ck,_v) => {
    var _co:i7.ProductManagementComponent = _v.component;
    const currVal_0:any = _co.idToBlur;
    _ck(_v,1,0,currVal_0);
    const currVal_2:any = 'Search by Product Name, HS Code or Company Name';
    const currVal_3:any = _co.query;
    _ck(_v,8,0,currVal_2,currVal_3);
    const currVal_4:any = (_co.products.length > 0);
    _ck(_v,12,0,currVal_4);
    const currVal_5:any = (_co.products.length == 0);
    _ck(_v,15,0,currVal_5);
    const currVal_6:any = (_co.products.length > 0);
    _ck(_v,18,0,currVal_6);
  },(_ck,_v) => {
    var _co:i7.ProductManagementComponent = _v.component;
    const currVal_1:any = _co.idToBlur;
    _ck(_v,3,0,currVal_1);
  });
}
export function View_ProductManagementComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'product-management',
      ([] as any[]),(null as any),[['window','popstate']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:popstate' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).unBlurMenu($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_ProductManagementComponent_0,RenderType_ProductManagementComponent)),
      i0.ɵdid(114688,(null as any),0,i7.ProductManagementComponent,[i14.ActivatedRoute,
          i10.ProductService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ProductManagementComponentNgFactory:i0.ComponentFactory<i7.ProductManagementComponent> = i0.ɵccf('product-management',
    i7.ProductManagementComponent,View_ProductManagementComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/app/components/Managment/productManagement/productManagement.component.ngfactory.ts